import { useCallback, useEffect, useRef } from 'react'

import { useBroadcast } from '../../hooks'
import { useAppDispatch, useAppSelector } from '../../store'
import { logout } from '../LoginForm/actions'

type Message =
  | { action: 'sign-out', key: string }

export function AuthStateListener (): JSX.Element | null {
  let key = Math.random().toString(36).substring(2)
  let dispatch = useAppDispatch()

  let profile = useAppSelector(state => state.auth.profile)
  let sub = profile?.sub
  let subRef = useRef(sub)

  let handleMessage = useCallback((event: MessageEvent) => {
    let data = event.data as unknown

    if (!data || typeof data !== 'object') {
      return
    }

    let message = data as Message

    if (message.action === 'sign-out') {
      if (message.key === key) {
        return
      }

      dispatch(logout())
    }
  }, [ key, dispatch ])

  let handleError = useCallback((event: MessageEvent) => {
    console.error('error', event)
  }, [])

  let [ , post ] = useBroadcast({
    channel: 'auth-state',
    handleMessage,
    handleError
  })

  useEffect(() => {
    let previousSub = subRef.current
    subRef.current = sub

    let shouldPost = typeof sub !== 'string' && previousSub !== sub

    if (!shouldPost) {
      return
    }

    let message: Message = {
      action: 'sign-out',
      key
    }

    post(message)
  }, [ sub, post, key ])

  return null
}
